import React, {Component, Fragment} from "react"
import {connect} from "react-redux"
import {string} from "prop-types"
import Styled, {css} from "styled-components"
// UI
import {Container, Row, Col} from "@uprise/grid"
import {ProgressBar} from "@uprise/charts"
import {Card} from "@uprise/card"
import {H2, H3, H5} from "@uprise/headings"
import {ExtraSmall} from "@uprise/text"
import {List} from "@uprise/list"

// Spacing
import {spacing} from "@uprise/spacing"
// Colors
import {backgrounds, extended, primary} from "@uprise/colors"

const PracticeStyle = Styled.section`
      width: 100%;
      height: 100%;
`

const Content = Styled.section`
	width: 100%;
	padding: 25px;
`

export const PracticeTask = ({className, practice}) => {
	return (
		<PracticeStyle>
			<H3 className='m-b-4'>Practice</H3>
			<Card backgroundColor={backgrounds.white}>
				<Content dangerouslySetInnerHTML={{__html: practice}} />
			</Card>
		</PracticeStyle>
	)
}

PracticeTask.propTypes = {
	practice: string.isRequired
}
